import React from 'react';
import update from 'react-addons-update';
import 'react-mdl/extra/material.js';
import {Textfield, Checkbox} from 'react-mdl';
import SMRailsBridge from 'lib/SMRailsBridge.js.erb';
import SMFormValidationMessage from 'components/dashboard/form/SMFormValidationMessage';
import SMFormatHelper from 'components/helpers/SMFormatHelper';
import SMOwnerResource from 'resources/SMOwnerResource.js';
import sprintf from 'sprintf';

class SMHostEntryView extends React.Component {
  constructor(props){
    super(props);

    this.state = {
      users: [{
        family_name: '',
        given_name: '',
        email: '',
        password: '',
        password_confirmation: '',
        accept_term_of_service: '0',
      }],
      accept_term_of_host: '0',
      tel: '',
      errors: [],
    };
  }

  componentDidMount() {
    if (this.props.errorMessage) {
      $(this.refs.formContent).showFailMessage(this.props.errorMessage);
    }
  }

  textFieldDidChange(e) {
    const key = e.currentTarget.name;
    const val = e.currentTarget.value;

    this.setState({
      users: update(this.state.users, {0: {[key]: {$set: val}}})
    });
  }


  ownerTextFieldDidChange(e) {
    const key = e.currentTarget.name;
    const val = e.currentTarget.value;

    this.setState({
      [key]: val
    });
  }

  checkBoxDidChange(e) {
    const key = e.currentTarget.name;
    const val = e.currentTarget.value;

    if (key === 'accept_term_of_host') {
      this.setState({
        accept_term_of_host: this.state.accept_term_of_host === '1' ? '0' : '1'
      });
    } else {
      this.setState({
        users: update(this.state.users, {0: {accept_term_of_service: {$set: this.state.users[0].accept_term_of_service === '1' ? '0' : '1'}}})
      });
    }
  }

  handleClickHostEntryButton(e) {
    $("html,body").animate({scrollTop: $(this.refs.form).offset().top}, "slow");
  }

  handleClickSubmitButton(e) {
    // 同時登録の時に必須にするためクライアント側でチェックを行う
    if (this.state.tel == '') {
      this.setState({
        errors: [{"resource":"Owner", "field": "tel", "message": sprintf(I18n.t("service.error_000002"), I18n.t('service.label_000111'))}]
      });
      return;
    }

    SMOwnerResource.postOwner(this.state, (data, error, xhr) => {
      if (xhr.status === 201 && !error) {
        window.location.href = Routes.signed_up_home_index_path({user_id: data.owners_users[0]["user"]["username"]});
      } else {
        console.error(xhr.responseJSON.errors);
        this.setState({
          errors: xhr.responseJSON.errors
        });
      }
    });
  }

  renderHostEntryButton() {
    if (this.props.currentUser) {
      return(
        <form action={Routes.owners_path()} method="post">
          <input type="hidden" name="authenticity_token" value={this.props.authenticityToken} />
          <input type="submit" value="ホスト登録はこちら" className="hostlp-entry__btn-item button-green" />
          <p className="ta-c mt15">ご登録前に<a href={Routes.terms_of_partner_for_new_owners_dashboard_about_index_path()} target="_blank" className="a__underline">ホスト規約</a>をお読みください。</p>
        </form>
      );
    } else {
      return(
        <div className="hostlp-entry__btn">
          <a onClick={this.handleClickHostEntryButton.bind(this)} className="hostlp-entry__btn-item button-green" >ホスト登録はこちら</a>
        </div>
      );
    }
  }

  renderTopForm() {
    if (this.props.currentUser) {
      return(
        <form action={Routes.owners_path()} method="post">
          <input type="hidden" name="authenticity_token" value={this.props.authenticityToken} />
          <div className="col-md-4">
            <div className="row signup-box__md-top hostlp-heroimg__form hostlp-heroimg__form-regist">
              <div className="col-sm-12 ta-c mt10">
                <p className="hostlp-heroimg__regist-comment">スペースの情報を登録するだけ！<br />いますぐホストになろう！</p>
              </div>
              <div className="col-sm-12">
                <input type="submit" name="commit" value="ホスト登録" className="button-green hostlp-heroimg__regist-button" />
                <p className="ta-c mt5">ご登録前に<a target="_blank" href={Routes.terms_of_partner_for_new_owners_dashboard_about_index_path()} className="a__underline">ホスト規約</a>をお読みください。</p>
              </div>
            </div>
          </div>
        </form>
      );
    } else {
      return(
        <div className="col-md-4">
          <div className="row signup-box__md-top hostlp-heroimg__form">
            <div className="col-sm-12 col-md-6">
              <Textfield
                onChange={this.textFieldDidChange.bind(this)}
                name="family_name"
                label={I18n.t("service.label_000078")}
                className="w100pa"
                value={this.state.users[0]['family_name']}
              />
              <SMFormValidationMessage
                name="users.family_name"
                options={{ className: "signup-box__required" }}
                withIcon={true}
                errorText={
                  SMFormatHelper.errorText('User', 'users.family_name', this.state.errors) ||
                  SMFormatHelper.errorText('Owner', 'family_name', this.state.errors)
                }
              />
            </div>
            <div className="col-sm-12 col-md-6">
              <Textfield
                onChange={(e) => this.textFieldDidChange(e)}
                name="given_name"
                label={I18n.t("service.label_000079")}
                className="w100pa"
                value={this.state.users[0]['given_name']}
              />
              <SMFormValidationMessage
                name="users.given_name"
                options={{ className: "signup-box__required" }}
                withIcon={true}
                errorText={
                  SMFormatHelper.errorText('User', 'users.given_name', this.state.errors) ||
                  SMFormatHelper.errorText('Owner', 'given_name', this.state.errors)
                }
              />
            </div>
            <div className="col-sm-12">
              <Textfield
                onChange={(e) => this.textFieldDidChange(e)}
                name="email"
                label={I18n.t("service.label_000500")}
                className="w100pa"
                value={this.state.users[0]['email']}
              />
              <SMFormValidationMessage
                name="users.email"
                options={{ className: "signup-box__required" }}
                withIcon={true}
                errorText={
                  SMFormatHelper.errorText('User', 'users.email', this.state.errors) ||
                  SMFormatHelper.errorText('Owner', 'email', this.state.errors)
                }
              />
            </div>
            <div className="col-sm-12">
              <Textfield
                onChange={(e) => this.ownerTextFieldDidChange(e)}
                name="tel"
                label={I18n.t("service.label_000111")}
                className="w100pa"
                value={this.state.tel}
              />
              <SMFormValidationMessage
                name="owner.tel"
                options={{ className: "signup-box__required" }}
                withIcon={true}
                errorText={
                  SMFormatHelper.errorText('Owner', 'tel', this.state.errors)
                }
              />
            </div>
            <div className="col-sm-12">
              <Textfield
                onChange={(e) => this.textFieldDidChange(e)}
                type="password"
                className="w100pa"
                name="password"
                label={I18n.t("service.label_000501")}
                value={this.state.users[0]['password']}
              />
              <SMFormValidationMessage name="users.password" options={{ className: "signup-box__required" }} withIcon={true} errorText={SMFormatHelper.errorText('User', 'users.password', this.state.errors)} />
            </div>
            <div className="col-sm-12">
              <Textfield
                onChange={(e) => this.textFieldDidChange(e)}
                type="password"
                className="w100pa"
                name="password_confirmation"
                label={I18n.t("service.label_000505")}
                value={this.state.users[0]['password_confirmation']}
              />
              <SMFormValidationMessage name="users.password_confirmation" options={{ className: "signup-box__required" }} withIcon={true} errorText={SMFormatHelper.errorText('User', 'users.password_confirmation', this.state.errors)} />
            </div>
            <div className="col-sm-12 mt10">
              <p className="signup-box__wrapper-form-notes">ご登録前に<a href={Routes.terms_about_index_path()} className="a__underline" target="_blank">スペースマーケット利用規約</a>と<a href={Routes.terms_of_partner_for_new_owners_dashboard_about_index_path()} className="a__underline" target="_blank">ホスト規約</a>をお読みください。</p>
              <Checkbox
                id="checkbox-1"
                ref="checkbox"
                name="accept_term_of_service"
                label={I18n.t("service.label_000089")}
                checked={this.state.users[0]['accept_term_of_service'] === '1'}
                onChange={this.checkBoxDidChange.bind(this)}
              />
              <SMFormValidationMessage name="users.accept_term_of_service" options={{ className: "signup-box__required" }} withIcon={true} errorText={SMFormatHelper.errorText('User', 'users.accept_term_of_service', this.state.errors)} />
              <Checkbox
                id="checkbox-2"
                label="ホスト規約に同意する"
                name="accept_term_of_host"
                checked={this.state.accept_term_of_host === '1'}
                onChange={this.checkBoxDidChange.bind(this)}
              />
              <SMFormValidationMessage name="accept_term_of_host" options={{ className: "signup-box__required" }} withIcon={true} errorText={SMFormatHelper.errorText('Owner', 'accept_term_of_host', this.state.errors)} />
            </div>
            <div className="col-sm-12 hostlp-heroimg__form-hr">
              <input onClick={this.handleClickSubmitButton.bind(this)} type="submit" name="commit" value="ホスト登録" className="button-green mt20 pt15 pb15 w100per" />
            </div>
            <div className="col-sm-12 hostlp-heroimg__form-hr">
              <div className="signup-box__wrapper-fb hostlp-heroimg__form-fb">
                <a href={Routes.user_omniauth_authorize_path('facebook')} className="button-facebook pt15 pb15 w100per"><span className="signup-box__sns-button">Facebookで登録</span></a>
              </div>
            </div>
            <div className="col-sm-12 ta-c">
              <p>すでにアカウントをお持ちの方は<a href={Routes.new_user_session_path()}>ログイン</a></p>
            </div>
          </div>
        </div>
      );
    }
  }

  renderBottomForm() {
    if (this.props.currentUser) {
      return(
        <form action={Routes.owners_path()} method="post">
          <input type="hidden" name="authenticity_token" value={this.props.authenticityToken} />
          <div className="hostlp-entry__btn">
            <input type="submit" className="hostlp-entry__btn-item button-green" value="ホスト登録はこちら" />
            <p className="hostlp-form__attention">ご登録前に<a target="_blank" href={Routes.terms_of_partner_for_new_owners_dashboard_about_index_path()} className="a__underline">ホスト規約</a>をお読みください。</p>
          </div>
        </form>
      );
    } else {
      return(
        <div className="row signup-box__md-top hostlp-form__inner">
          <div className="col-sm-12 col-md-6 mb10">
            <Textfield
              onChange={(e) => this.textFieldDidChange(e)}
              name="family_name"
              label={I18n.t("service.label_000078")}
              className="w100pa"
              value={this.state.users[0]['family_name']}
            />
            <SMFormValidationMessage
              name="users.family_name"
              options={{ className: "signup-box__required" }}
              withIcon={true}
              errorText={
                SMFormatHelper.errorText('User', 'users.family_name', this.state.errors) ||
                SMFormatHelper.errorText('Owner', 'family_name', this.state.errors)
              }
            />
          </div>
          <div className="col-sm-12 col-md-6 mb10">
            <Textfield
              onChange={(e) => this.textFieldDidChange(e)}
              name="given_name"
              label={I18n.t("service.label_000079")}
              className="w100pa"
              value={this.state.users[0]['given_name']}
            />
            <SMFormValidationMessage
              name="users.given_name"
              options={{ className: "signup-box__required" }}
              withIcon={true}
              errorText={
                SMFormatHelper.errorText('User', 'users.given_name', this.state.errors) ||
                SMFormatHelper.errorText('Owner', 'given_name', this.state.errors)
              }
            />
          </div>
          <div className="col-sm-12 mb10">
            <Textfield
              onChange={(e) => this.textFieldDidChange(e)}
              name="email"
              label={I18n.t("service.label_000500")}
              className="w100pa"
              value={this.state.users[0]['email']}
            />
            <SMFormValidationMessage
              name="users.email"
              options={{ className: "signup-box__required" }}
              withIcon={true}
              errorText={
                SMFormatHelper.errorText('User', 'users.email', this.state.errors) ||
                SMFormatHelper.errorText('Owner', 'email', this.state.errors)
              }
            />
          </div>
          <div className="col-sm-12 mb10">
            <Textfield
              onChange={(e) => this.ownerTextFieldDidChange(e)}
              name="tel"
              label={I18n.t("service.label_000111")}
              className="w100pa"
              value={this.state.tel}
            />
            <SMFormValidationMessage
              name="owner.tel"
              options={{ className: "signup-box__required" }}
              withIcon={true}
              errorText={
                SMFormatHelper.errorText('Owner', 'tel', this.state.errors)
              }
            />
          </div>
          <div className="col-sm-12 mb10">
            <Textfield
              onChange={(e) => this.textFieldDidChange(e)}
              type="password"
              className="w100pa"
              name="password"
              label={I18n.t("service.label_000501")}
              value={this.state.users[0]['password']}
            />
            <SMFormValidationMessage name="users.password" options={{ className: "signup-box__required" }} withIcon={true} errorText={SMFormatHelper.errorText('User', 'users.password', this.state.errors)} />
          </div>
          <div className="col-sm-12 mb10">
            <Textfield
              onChange={(e) => this.textFieldDidChange(e)}
              type="password"
              className="w100pa"
              name="password_confirmation"
              label={I18n.t("service.label_000505")}
              value={this.state.users[0]['password_confirmation']}
            />
            <SMFormValidationMessage name="users.password_confirmation" options={{ className: "signup-box__required" }} withIcon={true} errorText={SMFormatHelper.errorText('User', 'users.password_confirmation', this.state.errors)} />
          </div>
          <div className="col-sm-12 mb20 mt10">
            <p className="signup-box__wrapper-form-notes">ご登録前に<a href={Routes.terms_about_index_path()} className="a__underline" target="_blank">スペースマーケット利用規約</a>と<a href={Routes.terms_of_partner_for_new_owners_dashboard_about_index_path()} className="a__underline" target="_blank">ホスト規約</a>をお読みください。</p>
            <Checkbox
              id="checkbox-1"
              ref="checkbox"
              name="accept_term_of_service"
              label={I18n.t("service.label_000089")}
              checked={this.state.users[0]['accept_term_of_service'] === '1'}
              onChange={this.checkBoxDidChange.bind(this)}
            />
            <SMFormValidationMessage name="users.accept_term_of_service" options={{ className: "signup-box__required" }} withIcon={true} errorText={SMFormatHelper.errorText('User', 'users.accept_term_of_service', this.state.errors)} />
            <Checkbox
              id="checkbox-2"
              label="ホスト規約に同意する"
              name="accept_term_of_host"
              checked={this.state.accept_term_of_host === '1'}
              onChange={this.checkBoxDidChange.bind(this)}
            />
            <SMFormValidationMessage name="accept_term_of_host" options={{ className: "signup-box__required" }} withIcon={true} errorText={SMFormatHelper.errorText('Owner', 'accept_term_of_host', this.state.errors)} />
          </div>
          <div className="col-sm-12 hostlp-form__hr">
            <input onClick={this.handleClickSubmitButton.bind(this)} type="submit" name="commit" value="ホスト登録" className="button-green hostlp-form__regist" />
          </div>
          <div className="col-sm-12 hostlp-form__hr">
            <div className="signup-box__wrapper-fb hostlp-heroimg__form-fb">
              <a href={Routes.user_omniauth_authorize_path('facebook')} className="button-facebook hostlp-form__fb"><span className="signup-box__sns-button">Facebookで登録</span></a>
            </div>
          </div>
          <div className="col-sm-12 ta-c">
            <p>すでにアカウントをお持の方は<a href={Routes.new_user_session_path()}>ログイン</a></p>
          </div>
        </div>
      );
    }
  }

  render(){
    return(
      <div className="site-main" ref="formContent">
        <div className="host-lp">
          <div className="hostlp-heroimg">
            <div className="hostlp-heroimg__inner row">
              <div className="hostlp-heroimg__col col-md-8">
                <div className="obj-pub-free"><span>スペース掲載</span>無料</div>
                  <ul className="row hostlp-heroimg__point">
                    <li className="hostlp-heroimg__point-list"><span>スペースの収益化！</span></li>
                    <li className="hostlp-heroimg__point-list"><span>安心の機能満載！</span></li>
                    <li className="hostlp-heroimg__point-list"><span>サポートもしっかり！</span></li>
                  </ul>
                <h1 className="heroimg__title">空きスペースがお金に変わる！<br />利用ユーザー数30万人の<br />スペースマーケットで<br className="sm-hide" />今すぐ収益アップ！</h1>
                <p className="heroimg__lead">あなたがお持ちのスペースを1時間単位から貸すことができます。<br />
                  イベント開催・経営会議・社員研修などのビジネス利用から<br className="sm-hide" />結婚式・誕生会などのパーティー利用まで、幅広いシーンに利用されています。</p>
              </div>
              {this.renderTopForm()}
            </div>
          </div>
          <div className="hostlp-trouble">
            <div className="hostlp__band">
              <h2 className="hostlp__band-ttl">こんなお悩みありませんか？</h2>
            </div>
            <div className="hostlp__padding">
              <div className="col1">
                <ul className="hostlp__trouble__list">
                  <li><img src={SMRailsBridge.assetPath.troubleSample01} alt="店舗の売り上げをもっと伸ばしたい" /></li>
                  <li><img src={SMRailsBridge.assetPath.troubleSample02} alt="空き家を貸したいけど難しそう" /></li>
                  <li><img src={SMRailsBridge.assetPath.troubleSample03} alt="運用している不動産の空室が埋まらない" /></li>
                  <li><img src={SMRailsBridge.assetPath.troubleSample04} alt="新しい利用用途が浮かばない" /></li>
                  <li><img src={SMRailsBridge.assetPath.troubleSample05} alt="運用している施設の集客が難しい" /></li>
                  <li><img src={SMRailsBridge.assetPath.troubleSample06} alt="ほとんど仕事で家に帰らないので家賃がもったいない" /></li>
                </ul>
                <p className="hostlp__trouble__message">スペースマーケットで解決！</p>
              </div>
              {this.renderHostEntryButton()}
            </div>
          </div>
          <div className="hostlp-sample">
            <div className="hostlp__padding">
              <h2 className="hostlp-sample__ttl">スペースマーケット活用事例</h2>
                <div className="col1">
                  <div className="hostlp-sample__list">
                    <div className="hostlp-sample__space-img img-01 clearfix">
                      <p className="grow-point"><span className="grow-point__result">月次売上実績</span>656,532<span className="grow-point__yen">円</span></p>
                      <p className="obj-photo"><img src={SMRailsBridge.assetPath.imgSample01} alt="ASAGORO" /></p>
                      <div className="hostlp-sample__space-txt">
                        <h3 className="hostlp-sample__space-copy space-owner01">売上は月平均600,000円超え!</h3>
                        <p className="hostlp-sample__space-sentence">元々物件が素晴らしく、もっと多くの人にこの物件の良さを感じて欲しいと思い、スペースの貸出を始めました。スペースマーケットを利用してからはスペースとしての利用用途がかなり広がりました。法人の撮影や、最近では朗読や、落語、演劇などの個人の発表の場としても利用をされるようになりました。<br />元々自社だけで集客をしていましたがスペースマーケットのサービスは使いやすく、利用を開始してからも簡単にやり取りや売り上げの管理などを行うことができています。</p>
                        <h4 className="hostlp-sample__space-name">ASAGORO</h4>
                        <p className="hostlp-sample__space-intro">23区内にありながら、木々に囲まれ築93年を超す、昔ながらの風情あふれる平屋建ての人気古民家スペース。</p>
                        <ul className="hostlp-sample__space-info">
                          <li className="hostlp-sample__space-place"><i className="fa fa-map-marker"></i><span className="place-name">東京都中野区</span></li>
                          <li className="hostlp-sample__space-price"><i className="fa fa-yen"></i><span className="time-price">¥3,000~¥15,000/時間</span><span className="stay-price">¥22,000〜￥120,000/日</span></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="hostlp-sample__list">
                    <div className="hostlp-sample__space-img img-02 clearfix">
                      <p className="grow-point"><span className="grow-point__result">月次売上実績</span>351,540<span className="grow-point__yen">円</span></p>
                      <p className="obj-photo"><img src={SMRailsBridge.assetPath.imgSample02} alt="紫栄庵" /></p>
                      <div className="hostlp-sample__space-txt">
                        <h3 className="hostlp-sample__space-copy space-owner02">想定外の利用用途でホストを楽しんでいます！</h3>
                        <p className="hostlp-sample__space-sentence">スペースマーケットで貸出をしてからは意外にコスプレイヤーの方の撮影利用が多くとても驚きました。最初は意図していない利用用途だったので不安な気持ちもありましたが実際に貸出を行ってみるとコスプレイヤーの方は親切でマナーもよく安心して貸出をすることができました。いい意味で想定外の利用用途が増えることで利用者のいろいろなニーズが知れ成約数増加に繋がっているのだと思います。自分でも考えつかなかった用途が次々見つかるのは非常に面白く、ホストを楽しんでいます。</p>
                        <h4 className="hostlp-sample__space-name">紫栄庵</h4>
                        <p className="hostlp-sample__space-intro">約300坪の敷地と純和風のお庭。撮影、お茶会、着付け、食事会ほか様々に利用可能。</p>
                        <ul className="hostlp-sample__space-info">
                          <li className="hostlp-sample__space-place"><i className="fa fa-map-marker"></i><span className="place-name">神奈川県横浜市神奈川区</span></li>
                          <li className="hostlp-sample__space-price"><i className="fa fa-yen"></i><span className="time-price">¥3,000〜￥20,000/時間</span></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="hostlp-sample__list">
                    <div className="hostlp-sample__space-img img-03 clearfix">
                      <p className="grow-point"><span className="grow-point__result">月次売上実績</span>379,254<span className="grow-point__yen">円</span></p>
                      <p className="obj-photo"><img src={SMRailsBridge.assetPath.imgSample03} alt="ピース" /></p>
                      <div className="hostlp-sample__space-txt">
                        <h3 className="hostlp-sample__space-copy space-owner03">空いている時間で賃貸以上の収益に！</h3>
                        <p className="hostlp-sample__space-sentence">元々自習室として運営していた施設の集客に困っており、施設を会議室に変えて運営を開始し直したタイミングで日経トレンディを見てスペースマーケットを利用し始めました。スペースマーケットで貸出を開始してからはすぐに売り上げが上がるようになり、値付けを工夫したこともあって、会議室のカテゴリーで1位を取るまでになりました。また賃貸に出せば自社では使えなくなりますが、スペースマーケットで貸出を行うことで空いている時は自分たちで利用でき、空いている時間で賃貸以上の収益を上げることができているので非常に便利だと感じています。</p>
                        <h4 className="hostlp-sample__space-name">ピース</h4>
                        <p className="hostlp-sample__space-intro">ニコニコ生放送のゲーム実況チャンネルの番組制作に利用しているスタジオや控室・小会議室を利用可能。</p>
                        <ul className="hostlp-sample__space-info">
                          <li className="hostlp-sample__space-place"><i className="fa fa-map-marker"></i><span className="place-name">東京都豊島区</span></li>
                          <li className="hostlp-sample__space-price"><i className="fa fa-yen"></i><span className="time-price">¥490〜￥1,080/時間</span><span className="stay-price">¥3,980〜￥11,980/日</span></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="hostlp-sample__list">
                    <div className="hostlp-sample__space-img img-04 clearfix">
                      <p className="grow-point"><span className="grow-point__result">月次売上実績</span>2,021,500<span className="grow-point__yen">円</span></p>
                      <p className="obj-photo"><img src={SMRailsBridge.assetPath.imgSample04} alt="hanami" /></p>
                      <div className="hostlp-sample__space-txt">
                        <h3 className="hostlp-sample__space-copy space-owner04">法人利用の機会も増え売上200万円突破！</h3>
                        <p className="hostlp-sample__space-sentence">今までは飲食店舗として運営していたこともあり、個人でのパーティーでの利用が大多数でしたが、スペースマーケットを利用し始めてからは法人利用の機会が増えました。特に路面店舗の特性を生かして頂き、数ヶ月単位での企業のPRイベントでご利用頂くことが多く通常どおり飲食店を営業しながら、収益を上げることができ、さらにPR効果によって通常よりも多くのお客様に足を運んでもらうこともできました。お店の新しい収益の柱ができるとは利用を開始した頃は思ってもいませんでした。
                        </p>
                        <h4 className="hostlp-sample__space-name">hanami</h4>
                        <p className="hostlp-sample__space-intro">表参道駅から徒歩3分という好立地、新築一軒家。1階はカフェスペース・2階はイベントスペースで、雰囲気の違うところも魅力。</p>
                        <ul className="hostlp-sample__space-info">
                          <li className="hostlp-sample__space-place"><i className="fa fa-map-marker"></i><span className="place-name">東京都渋谷区</span></li>
                          <li className="hostlp-sample__space-price"><i className="fa fa-yen"></i><span className="time-price">¥15,000/時間</span><span className="stay-price">¥180,000/日</span></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="hostlp-sample__list">
                    <div className="hostlp-sample__space-img img-05 clearfix">
                      <p className="grow-point"><span className="grow-point__result">月次売上実績</span>163,734<span className="grow-point__yen">円</span></p>
                      <p className="obj-photo"><img src={SMRailsBridge.assetPath.imgSample05} alt="トリップモール" /></p>
                      <div className="hostlp-sample__space-txt">
                        <h3 className="hostlp-sample__space-copy space-owner05">運用している不動産の空室時間の稼働が増加！</h3>
                        <p className="hostlp-sample__space-sentence">運用している不動産の物件に空き時間があったので、少しでも空き時間を少なくできればと思い、スペースマーケットの利用を開始しました。利用を始めてみると思っていた以上に運用施設とスペースマーケットの親和性が高く、本来の用途とは異なるパーティーや撮影などで空室時間の稼働が増加しました。スペースマーケットを使った空き時間の活用の可能性は今後も広がっていくと感じています。</p>
                        <h4 className="hostlp-sample__space-name">トリップモール</h4>
                        <p className="hostlp-sample__space-intro">都内各所で撮影・パーティなどに利用できる様々なスペースをご提供。</p>
                        <ul className="hostlp-sample__space-info">
                          <li className="hostlp-sample__space-place"><i className="fa fa-map-marker"></i><span className="place-name">東京都港区</span></li>
                          <li className="hostlp-sample__space-price"><i className="fa fa-yen"></i><span className="time-price">¥5,000/時間</span><span className="stay-price">¥28,500/日</span></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="hostlp-sample__list">
                    <div className="hostlp-sample__space-img img-06 clearfix">
                      <p className="grow-point"><span className="grow-point__result">月次売上実績</span>813,218<span className="grow-point__yen">円</span></p>
                      <p className="obj-photo"><img src={SMRailsBridge.assetPath.imgSample06} alt="代々木デザイナーズ ラウンジスペース" /></p>
                      <div className="hostlp-sample__space-txt">
                        <h3 className="hostlp-sample__space-copy space-owner06">不在時の貸出で想定以上の収入に！</h3>
                        <p className="hostlp-sample__space-sentence">不動産購入後の運用方法の一つとして、本サービスを利用させて頂きました。日中は家にいないことがほとんどの為、9:00-21:00で自宅を貸し出した結果、月に20~40万円といった想定以上の収入が発生し、喜ばしく思っております。またスペースマーケットの全体ランキング一位も獲得でき、稼働数が飛躍的に増加しました。しかし、日々品質の高いスペースが次々と登場しているため、気が抜けない状況です。今後も当スペースでは運用改善・品質向上に努める所存です。</p>
                        <h4 className="hostlp-sample__space-name">代々木デザイナーズ ラウンジスペース</h4>
                        <p className="hostlp-sample__space-intro">リノベーションしたデザイナーズ物件。代々木公園が近く非常に空気がよい環境の人気スペース</p>
                        <ul className="hostlp-sample__space-info">
                          <li className="hostlp-sample__space-place"><i className="fa fa-map-marker"></i><span className="place-name">東京都渋谷区</span></li>
                          <li className="hostlp-sample__space-price"><i className="fa fa-yen"></i><span className="time-price">¥2,000〜￥5,000/時間</span><span className="stay-price">¥25,000〜￥45,000/日</span></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            <div className="sample-company">
              <h3 className="sample-company__ttl">こんな企業もスペースを利用しています！</h3>
              <div className="container">
                <ul className="sample-company__list">
                  <li><img src={SMRailsBridge.assetPath.comlogoTechasia} alt="TECH IN ASIA" /></li>
                  <li><img src={SMRailsBridge.assetPath.comlogoBase} alt="BASE" /></li>
                  <li><img src={SMRailsBridge.assetPath.comlogoVenture} alt="Ventures" /></li>
                  <li><img src={SMRailsBridge.assetPath.comlogoCrazy} alt="CRAZY" /></li>
                  <li><img src={SMRailsBridge.assetPath.comlogoKp} alt="KAIZEN PLATFORM" /></li>
                  <li><img src={SMRailsBridge.assetPath.comlogoYjfx} alt="YJFX!" /></li>
                  <li><img src={SMRailsBridge.assetPath.comlogoWantedly} alt="WANTEDLY" /></li>
                  <li><img src={SMRailsBridge.assetPath.comlogoLep} alt="Link Event Produce Inc." /></li>
                  <li><img src={SMRailsBridge.assetPath.comlogoTranscosmos} alt="transcosmos inc." /></li>
                </ul>
              </div>
              {this.renderHostEntryButton()}
            </div>
          </div>
          <div className="hostlp-function">
            <div className="hostlp__band">
              <h2 className="hostlp__band-ttl">安心の機能が満載！</h2>
            </div>
            <div className="hostlp__padding">
              <div className="col1">
                <p className="hostlp-function__lead">
                <span>ホストをリスクから守る機能</span>もしっかりご用意しています。
                </p>
              </div>
              <div className="hostlp-function__list">
                <div className="container">
                  <div className="row">
                    <div className="hostlp-function__item col-sm-4">
                      <span className="hostlp-function__point">POINT1</span>
                      <h3 className="hostlp-function__ttl">信頼できるゲストの予約を選定</h3>
                      <img src={SMRailsBridge.assetPath.function01} alt="信頼できるゲストの予約を選定" />
                      <p className="hostlp-function__sentence">メッセージでのやり取りやゲストの取引実績から予約の承認／否認を選択することが出来るので、信頼できるゲストからのみ予約を受け付けることができます。</p>
                    </div>
                    <div className="hostlp-function__item col-sm-4">
                      <span className="hostlp-function__point">POINT2</span>
                      <h3 className="hostlp-function__ttl">プライバシーも安心の<br />メッセージ機能</h3>
                      <img src={SMRailsBridge.assetPath.function02} alt="プライバシーも安心のメッセージ機能" />
                      <p className="hostlp-function__sentence">メッセージ機能を活用し、予約が成立するまで電話番号やメールアドレスを公開せずに連絡を取ることができます。</p>
                    </div>
                    <div className="hostlp-function__item col-sm-4">
                      <span className="hostlp-function__point">POINT3</span>
                      <h3 className="hostlp-function__ttl">突然のキャンセルも回避</h3>
                      <img src={SMRailsBridge.assetPath.function03} alt="突然のキャンセルも回避" />
                      <p className="hostlp-function__sentence">スペースマーケットを通じて受ける予約はすべて事前決済制。ゲストに因る急なキャンセルが生じた場合でもキャンセルポリシーを確実に適用できます。</p>
                  </div>
                </div>
              </div>
              {this.renderHostEntryButton()}
            </div>
          </div>
          <div className="hostlp-support">
            <div className="hostlp__band">
              <h2 className="hostlp__band-ttl">困った時も安心のサポート体制！</h2>
            </div>
            <div className="hostlp__padding">
              <div className="container">
                <div className="row">
                  <p className="col-xs-12 col-sm-4 hostlp-support__img"><img src={SMRailsBridge.assetPath.imgSupport} alt="" /></p>
                  <div className="col-xs-12 col-sm-8 hostlp-support__txt">
                    <h3 className="hostlp-support__catch">お悩みはご相談ください！</h3>
                    <p className="hostlp-support__lead">人気のあるページをどのように作ったら良いのか分からなかったり、操作や処理の仕方など不明点が出てきてしまっても安心。<br />
                    写真の選定、説明文の作成ほか、集客の仕方やページの運営についてなどスペースマーケットがしっかりサポートします。</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="hostlp-pub-free">
            <div className="hostlp__band">
              <h2 className="hostlp__band-ttl">掲載は無料！</h2>
            </div>
            <div className="hostlp__padding">
              <div className="col1">
                <h3 className="hostlp-pub-free__catch"><img src={SMRailsBridge.assetPath.pubFree} alt="掲載料￥0" /></h3>
                <p className="hostlp-pub-free__lead">掲載は無料！スペースが利用された場合に、利用料金より手数料を除いた金額をご登録銀行口座へ振込みさせて頂きます。</p>
                <div className="container">
                  <ul className="row hostlp-pub-fee__list">
                    <li className="col-xs-12 col-sm-4 hostlp-pub-fee__item"><i className="fa fa-clock-o"></i><span className="fee-pattern">時間レンタル</span>成約金額の30％</li>
                    <li className="col-xs-12 col-sm-4 hostlp-pub-fee__item"><i className="fa fa-sun-o"></i><span className="fee-pattern">1日レンタル</span>成約金額の30％</li>
                    <li className="col-xs-12 col-sm-4 hostlp-pub-fee__item"><i className="fa fa-moon-o"></i><span className="fee-pattern">宿泊</span>成約金額の10％</li>
                  </ul>
                </div>
              </div>
              {this.renderHostEntryButton()}
            </div>
          </div>
          <div className="hostlp-pub-media">
            <div className="hostlp__band">
              <h2 className="hostlp__band-ttl">メディアにも多数掲載！</h2>
            </div>
            <div className="hostlp__padding">
              <div className="col1">
                <h3 className="hostlp-pub-media__catch">Yahoo!ニュースや日本経済新聞他、多数の大手メディアにも掲載！</h3>
                <ul className="static-appeal__list clearfix">
                  <li><a href="http://spacemarket.co.jp/archives/5331" target="_blank"><img alt="NHK" src="//d1nc9n01ephlj6.cloudfront.net/assets/service/footer/media/nhk-e4b7e7e069e55b2b7bb7a398dc0d9f94.png" /></a></li>
                  <li><a href="http://spacemarket.co.jp/archives/5381" target="_blank"><img alt="日本経済新聞" src="//d1nc9n01ephlj6.cloudfront.net/assets/service/footer/media/nikkei-2bdc8049f6e4377fb42e34a8910fd68d.png" /></a></li>
                  <li><a href="http://spacemarket.co.jp/archives/6061" target="_blank"><img alt="フジテレビ" src="//d1nc9n01ephlj6.cloudfront.net/assets/service/footer/media/fujitv-c60c4071320f8dd3db2eae316536bc6c.png" id="exifviewer-img-3" /></a></li>
                  <li><a href="http://spacemarket.co.jp/archives/5621" target="_blank"><img alt="TBS" src="//d1nc9n01ephlj6.cloudfront.net/assets/service/footer/media/tbs-137aa03808c228b5f4208182467adaae.png" /></a></li>
                  <li><a href="http://spacemarket.co.jp/archives/5621" target="_blank"><img alt="朝日新聞" src="//d1nc9n01ephlj6.cloudfront.net/assets/service/footer/media/asahi-9b3b219f86d7f7cbc390348a824e3837.png" id="exifviewer-img-8" /></a></li>
                  <li><a href="http://diamond.jp/articles/-/60963" target="_blank"><img alt="Yahoo!ニュース" src="//d1nc9n01ephlj6.cloudfront.net/assets/service/footer/media/yahoo-9c996863ec14c229ba9416de3a4cf7de.png" /></a></li>
                  <li><a href="http://spacemarket.co.jp/archives/5471" target="_blank"><img alt="YOMIURI ONLINE" src="//d1nc9n01ephlj6.cloudfront.net/assets/service/footer/media/yomiuri-6d636772d44039b6ea404eba0333c052.png" id="exifviewer-img-23" /></a></li>
                  <li><a href="http://spacemarket.co.jp/archives/721" target="_blank"><img alt="J-WAVE" src="//d1nc9n01ephlj6.cloudfront.net/assets/service/footer/media/jwave-91f2ecc6172b003de0083369703656c8.png" id="exifviewer-img-2" /></a></li>
                  <li><a href="http://spacemarket.co.jp/archives/7261" target="_blank"><img alt="REUTERS" src="//d1nc9n01ephlj6.cloudfront.net/assets/service/footer/media/reuters-9455c113ac25f08820bd0aa0053e3f93.png" id="exifviewer-img-4" /></a></li>
                  <li><a href="http://spacemarket.co.jp/archives/7351" target="_blank"><img alt="R25" src="//d1nc9n01ephlj6.cloudfront.net/assets/service/footer/media/r25-7fd74a684c22ef57e5004f40ee75e071.png" id="exifviewer-img-25" /></a></li>
                </ul>
              </div>
            </div>
          </div>
          <div className="hostlp-flow">
            <div className="hostlp__band">
              <h2 className="hostlp__band-ttl">スペース掲載までの流れ</h2>
            </div>
            <div className="hostlp__padding">
              <h3 className="hostlp-flow__catch">Webだけで完結！掲載までの流れ</h3>
              <div className="hostlp-flow__list container">
                <div className="row hostlp-flow-box">
                  <div className="col-xs-6 col-md-3">
                    <div className="hostlp-flow__step-1 hostlp-flow__step">
                      <p className="host-lp-flow__thumbnail"><img src={SMRailsBridge.assetPath.flow01} alt="ゲスト登録" /></p>
                      <h3 className="hostlp-flow__step-title">ゲスト登録</h3>
                      <p>スペースマーケットへ<br />ゲスト登録をして頂きます。</p>
                    </div>
                  </div>
                  <div className="col-xs-6 col-md-3">
                    <div className="hostlp-flow__step-2 hostlp-flow__step">
                      <p className="host-lp-flow__thumbnail"><img src={SMRailsBridge.assetPath.flow02} alt="ホスト登録" /></p>
                      <h3 className="hostlp-flow__step-title">ホスト登録</h3>
                      <p>ゲスト登録の次は<br />ホスト登録をして頂きます。</p>
                    </div>
                  </div>
                  <div className="col-xs-6 col-md-3">
                    <div className="hostlp-flow__step-3 hostlp-flow__step">
                      <p className="host-lp-flow__thumbnail"><img src={SMRailsBridge.assetPath.flow03} alt="スペース情報入力・審査" /></p>
                      <h3 className="hostlp-flow__step-title">スペース情報入力・審査</h3>
                      <p>スペース詳細をご入力頂き、<br />スペースの審査を行います。</p>
                    </div>
                  </div>
                  <div className="col-xs-6 col-md-3">
                    <div className="hostlp-flow__step-4 hostlp-flow__step">
                      <p className="host-lp-flow__thumbnail"><img src={SMRailsBridge.assetPath.flow04} alt="掲載開始" /></p>
                      <h3 className="hostlp-flow__step-title">掲載開始</h3>
                      <p>審査が通ればスペースの<br />掲載スタート！</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div ref="form" className="hostlp-form">
            <div className="hostlp__padding">
              <h3 className="hostlp-form__title">今すぐあなたのスペースを掲載してみましょう</h3>
              <p className="hostlp-form__content">お持ちのスペースを今すぐ有効活用。あらゆるスペースが登録できます。</p>
              {this.renderBottomForm()}
            </div>
          </div>
        </div>
        </div>
      </div>
    );
  }
}

export default SMHostEntryView;



// WEBPACK FOOTER //
// ./app/javascript/components/pages/SMHostEntryView.jsx